import { AccountService } from './../../../@resources/services/account.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-consultation',
	templateUrl: './consultation.component.html',
	styleUrls: ['./consultation.component.scss']
})
export class ConsultationComponent implements OnInit {

	@Input() consultationId: any
	@Input() content: any;
	@Input() createdAt: any;
	@Input() customerId: any;
	@Input() index: any;
	@Output() delete: EventEmitter<number> = new EventEmitter<number>();
	constructor(private accountService: AccountService) { }

	ngOnInit(): void {
	}

	deleteConsultation(consultationId: any) {
		Swal.fire({
			title: '<div class="size-8 weight-700 text-primary">هل تريد حذف الأستشارة ؟</div>',
			showDenyButton: false,
			showCancelButton: true,
			confirmButtonColor: '#a90520',
			confirmButtonText: `حذف`,
			cancelButtonText: `رجوع`,
		}).then((result) => {
			if (result.isConfirmed) {
				this.accountService.deleteConsultation({ consultationId: consultationId, userId: this.customerId }).subscribe((res: any) => {
					this.delete.emit(this.index);
					Swal.fire('<div class="size-12 weight-700 text-primary">تم حذف الأستشارة</div>', '',
						'success')
				})
			}
		})
	}

}
